import React from 'react';
import { useTranslation , Trans } from 'react-i18next';

const PrivacyPolicyPage = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-gray-50 min-h-screen py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-4xl mx-auto bg-white shadow-lg rounded-xl overflow-hidden">
        
        {/* Header */}
        <div className="bg-[#1d5cab] px-8 py-6">
          <h1 className="text-3xl font-bold text-white">{t('privacy.header.title')}</h1>
          <p className="text-white mt-2">{t('privacy.header.effectiveDate')}</p>
        </div>

        {/* Content */}
        <div className="p-8 space-y-8 text-gray-700 leading-relaxed">
          
          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('privacy.sections.intro.title')}</h2>
            <p>
              <Trans 
                i18nKey="privacy.sections.intro.content" 
                values={{ company: t('nav.brand') }}
              >
              </Trans>
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">
              {t('privacy.sections.data.title')}</h2>
            <p className="mb-2">
              {t('privacy.sections.data.description')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('privacy.sections.usage.title')}</h2>
            <p>{t('privacy.sections.usage.description')}</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('privacy.sections.cookies.title')}</h2>
            <p>
              {t('privacy.sections.cookies.body')}
            </p>
            <p className="mt-2">
              {t('privacy.sections.cookies.body-2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('privacy.sections.retention.title')}</h2>
            <p>
              {t('privacy.sections.retention.body')}
            </p>
            <p className="mt-2">
              {t('privacy.sections.retention.body-2')}
            </p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('privacy.sections.rights.title')}</h2>
            <p>{t('privacy.sections.rights.description')}</p>
          </section>

          <section>
            <h2 className="text-xl font-bold text-gray-900 mb-3 border-b pb-2">{t('privacy.sections.contact.title')}</h2>
            <p>
              {t('terms.contact-1')}
            </p>
            <address className="not-italic mt-2 text-gray-600 bg-gray-50 p-4 rounded">
              <strong> {t('company.legal-entity')} </strong><br />
              {t('company.address-1')}<br />
              {t('company.address-2')}<br />
              {t('company.privacy-email')}<br />
             {t('privacy.sections.contact.officer')}  <span className="text-blue-600">dpo@somosmas.ch</span>
            </address>
            <p className="mt-4 text-sm">
               {t('privacy.sections.contact.authority')}  </p>
          </section>

        </div>

        {/* Footer */}
        <div className="bg-gray-100 px-8 py-4 text-center text-sm text-gray-500">
          {t('privacy.footer.copy')} &copy; {new Date().getFullYear()}
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicyPage;
